export const Modes = {
    None: '',
    Mock: 'mock',
};
